import { KnmSubjectTypesEnum } from 'KnmErknmPackage/ErknmSubjectModule/components/ErknmSubjectInfo';
import { IKnmErknmFormSubject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormSubject';
import { KnmSubjectItAccreditation } from 'KnmPackage/KnmSubjectModule/components/KnmSubjectItAccreditation';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { TextInput } from 'UIPackage/MainModule/components/TextInput';
import { Textarea } from 'UIPackage/MainModule/components/Textarea';

import { KnmNkoField } from '../../../KnmPackage/MainModule/components/KnmNkoField';
import { KnmSonkoField } from '../../../KnmPackage/MainModule/components/KnmSonkoField';
import { KnmMspField } from '../../../KnmPackage/MainModule/components/KnmMspField';
import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';

interface IPmResultOfInspectionResultDecisionOrganizationProps {
  pmSubject: IKnmErknmFormSubject;
  formRef: IKnmFormRef | undefined;
}

type PmResultOfInspectionResultDecisionOrganizationComponent = (
  props: IPmResultOfInspectionResultDecisionOrganizationProps,
) => JSX.Element | null;

const PmResultOfInspectionResultDecisionOrganizationInnField: PmResultOfInspectionResultDecisionOrganizationComponent = ({
  pmSubject,
}) => {
  return (
    <FieldBlock size="half" label="Идентификационный номер налогоплательщика (ИНН)" color="black">
      <TextInput disabled value={pmSubject.inn} />
    </FieldBlock>
  );
};

const PmResultOfInspectionResultDecisionOrganizationNameField: PmResultOfInspectionResultDecisionOrganizationComponent = ({
  pmSubject,
}) => {
  return (
    <FieldBlock label="Наименование проверяемого лица" color="black">
      <Textarea disabled value={pmSubject.organizationName} />
    </FieldBlock>
  );
};

const PmResultOfInspectionResultDecisionOrganizationAddressField: PmResultOfInspectionResultDecisionOrganizationComponent = ({
  pmSubject,
}) => {
  return (
    <FieldBlock label="Адрес места нахождения" color="black">
      <TextInput disabled value={pmSubject.locationAddress} />
    </FieldBlock>
  );
};

const PmResultOfInspectionResultDecisionOrganizationUR: PmResultOfInspectionResultDecisionOrganizationComponent = ({
  pmSubject,
  formRef,
}) => {
  const nkoValue = pmSubject.nkoForeignAgentsRegistryInclusionDate ? 'Да' : 'Нет';

  const isItText = () => {
    if (pmSubject.isPresentInItRegistry === undefined) {
      return '';
    }

    return pmSubject.isPresentInItRegistry ? 'Да' : 'Нет';
  };

  return (
    <>
      <Row>
        <FieldBlock size="half" label="Основной государственный регистрационный номер (ОГРН)" color="black">
          <TextInput disabled />
        </FieldBlock>
        <PmResultOfInspectionResultDecisionOrganizationInnField pmSubject={pmSubject} formRef={formRef} />
      </Row>
      <Row>
        <PmResultOfInspectionResultDecisionOrganizationNameField pmSubject={pmSubject} formRef={formRef} />
      </Row>
      <Row>
        <PmResultOfInspectionResultDecisionOrganizationAddressField pmSubject={pmSubject} formRef={formRef} />
      </Row>
      <Row>
        <KnmNkoField value={nkoValue} formRef={formRef} />
      </Row>
      <Row>
        <KnmMspField value={pmSubject.mspCode} formRef={formRef} isShowMessages={false} ervkId={pmSubject.ervkId} />
      </Row>
      <Row>
        <KnmSonkoField value={pmSubject.isSonko} formRef={formRef} isShowMessages={false} />
      </Row>
      <Row>
        <FieldBlock label="Наличие в реестре аккредитованных IT-организаций" placementLabel="left">
          <TextInput className="shared-row-field" disabled value={isItText()} />
        </FieldBlock>
      </Row>
      {pmSubject.isPresentInItRegistry && pmSubject.itAccreditationResponse && (
        <KnmSubjectItAccreditation itAccreditationResponse={pmSubject.itAccreditationResponse} />
      )}
    </>
  );
};

const PmResultOfInspectionResultDecisionOrganizationIP: PmResultOfInspectionResultDecisionOrganizationComponent = ({
  pmSubject,
  formRef,
}) => {
  return (
    <>
      <Row>
        <FieldBlock size="half" label="Основной государственный регистрационный номер (ОГРНИП)" color="black">
          <TextInput disabled value={pmSubject.ogrn} />
        </FieldBlock>
        <PmResultOfInspectionResultDecisionOrganizationInnField pmSubject={pmSubject} formRef={formRef} />
      </Row>
      <Row>
        <PmResultOfInspectionResultDecisionOrganizationNameField pmSubject={pmSubject} formRef={formRef} />
      </Row>
      <Row>
        <FieldBlock label="Место фактического осуществления деятельности" color="black">
          <TextInput disabled value={pmSubject.factualAddress} />
        </FieldBlock>
      </Row>
      <Row>
        <KnmMspField value={pmSubject.mspCode} formRef={formRef} isShowMessages={false} ervkId={pmSubject.ervkId} />
      </Row>
    </>
  );
};

const PmResultOfInspectionResultDecisionOrganizationFIZ: PmResultOfInspectionResultDecisionOrganizationComponent = ({
  pmSubject,
  formRef,
}) => {
  return (
    <>
      <Row>
        <PmResultOfInspectionResultDecisionOrganizationInnField pmSubject={pmSubject} formRef={formRef} />
        <FieldBlock size="half" label="Страховой номер индивидуального лицевого счета (СНИЛС)" color="black">
          <TextInput disabled value={pmSubject.snils} />
        </FieldBlock>
      </Row>
      <Row>
        <PmResultOfInspectionResultDecisionOrganizationNameField pmSubject={pmSubject} formRef={formRef} />
      </Row>
      <Row>
        <KnmMspField value={pmSubject.mspCode} formRef={formRef} isShowMessages={false} ervkId={pmSubject.ervkId} />
      </Row>
    </>
  );
};

const PmResultOfInspectionResultDecisionOrganizationIUR: PmResultOfInspectionResultDecisionOrganizationComponent = ({
  pmSubject,
  formRef,
}) => {
  return (
    <>
      <Row>
        <FieldBlock label="Наименование" color="black">
          <Textarea disabled value={pmSubject.organizationName} />
        </FieldBlock>
      </Row>
      <Row>
        <FieldBlock label="Государство, в котором указанное юридическое лицо зарегистрировано" color="black">
          <TextInput disabled value={pmSubject.country?.label} />
        </FieldBlock>
      </Row>
      <Row>
        <KnmMspField value={pmSubject.mspCode} formRef={formRef} isShowMessages={false} ervkId={pmSubject.ervkId} />
      </Row>
    </>
  );
};

const PmResultOfInspectionResultDecisionOrganizationFIUR: PmResultOfInspectionResultDecisionOrganizationComponent = ({
  pmSubject,
  formRef,
}) => {
  return (
    <>
      <Row>
        <PmResultOfInspectionResultDecisionOrganizationInnField pmSubject={pmSubject} formRef={formRef} />
        <FieldBlock size="half" label="Номер записи об аккредитации в РАФП" color="black">
          <TextInput disabled value={pmSubject.rafpNza} />
        </FieldBlock>
      </Row>
      <Row>
        <FieldBlock label="Код причины постановки на учет (КПП)" color="black" size="half">
          <TextInput disabled value={pmSubject.kpp} />
        </FieldBlock>
      </Row>
      <Row>
        <FieldBlock label="Наименование организации" color="black">
          <Textarea disabled value={pmSubject.organizationName} />
        </FieldBlock>
      </Row>
      <Row>
        <PmResultOfInspectionResultDecisionOrganizationAddressField pmSubject={pmSubject} formRef={formRef} />
      </Row>
      <Row>
        <KnmMspField value={pmSubject.mspCode} formRef={formRef} isShowMessages={false} ervkId={pmSubject.ervkId} />
      </Row>
      <Row>
        <KnmSonkoField
          value={pmSubject.isSonko}
          checkByInnMessage={undefined}
          formRef={formRef}
          isShowMessages={false}
        />
      </Row>
    </>
  );
};

const PmResultOfInspectionResultDecisionOrganizationIFIZ: PmResultOfInspectionResultDecisionOrganizationComponent = ({
  pmSubject,
}) => {
  return (
    <>
      <Row>
        <FieldBlock label="Фамилия, имя, отчество (при наличии)" color="black">
          <TextInput disabled value={pmSubject.organizationName} />
        </FieldBlock>
      </Row>
      <Row>
        <FieldBlock label="Сведения о документе, удостоверяющем личность" color="black">
          <TextInput disabled value={pmSubject.document} />
        </FieldBlock>
      </Row>
      <Row>
        <FieldBlock label="Гражданство (при наличии)" color="black">
          <TextInput disabled value={pmSubject.country?.label} />
        </FieldBlock>
      </Row>
    </>
  );
};

export const PmResultOfInspectionResultDecisionControllingSubjectMap: Record<
  KnmSubjectTypesEnum,
  PmResultOfInspectionResultDecisionOrganizationComponent
> = {
  [KnmSubjectTypesEnum.UR]: PmResultOfInspectionResultDecisionOrganizationUR,
  [KnmSubjectTypesEnum.IP]: PmResultOfInspectionResultDecisionOrganizationIP,
  [KnmSubjectTypesEnum.FIZ]: PmResultOfInspectionResultDecisionOrganizationFIZ,
  [KnmSubjectTypesEnum.IUR]: PmResultOfInspectionResultDecisionOrganizationIUR,
  [KnmSubjectTypesEnum.FIUR]: PmResultOfInspectionResultDecisionOrganizationFIUR,
  [KnmSubjectTypesEnum.IFIZ]: PmResultOfInspectionResultDecisionOrganizationIFIZ,
  [KnmSubjectTypesEnum.OFFICIAL]: () => null,
} as const;
